import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  small: {
    ".MuiInputBase-input": {
      padding: "12px 0",
    },
  },
  clear: {
    color: "text.secondary",
    fontSize: "16px",
    cursor: "pointer",
  },
};

export default classes;
